<!--
全部工单管理
-->
<template>
	<div class="box-page" @click="resetTimer" v-loading="loading">
		<div class="flex-col-center box-title-line" style="padding-bottom: 0">
			<div class="box-title mb20" style="width: 85px">全部工单</div>
			<el-form :model="form" inline size="mini" class="search-form flex-1">
				<div>
					<el-form-item label="工单编号">
						<el-input v-model="form.sheetNumber" placeholder="请输入工单编号"></el-input>
					</el-form-item>
					<el-form-item label="关键词">
						<el-input v-model="form.keyword" placeholder="请输入关键词"></el-input>
					</el-form-item>
					<el-form-item label="发起时间">
						<el-date-picker v-model="form.date" type="daterange" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期" unlink-panels value-format="yyyy-MM-dd HH:mm:ss" clearable>
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSearch">搜索</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="text" @click="moreSearch=!moreSearch">{{moreSearch?'收起搜索':'更多搜索'}}</el-button>
					</el-form-item>
				</div>
				<div v-show="moreSearch">
					<el-form-item label="发起人">
						<el-select v-model="form.startUserId" placeholder="全部" filterable clearable>
							<el-option v-for="item in sheetParamsList.startUserList" :key="'start' + item.userId"
								:label="item.userName" :value="item.userId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="处理人">
						<el-select v-model="form.doUserId" placeholder="全部" filterable clearable>
							<el-option v-for="item in sheetParamsList.doUserList" :key="'do' + item.userId"
								:label="item.userName" :value="item.userId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="分配人">
						<el-select v-model="form.distributeUserId" placeholder="全部" filterable clearable>
							<el-option v-for="(item, index) in sheetParamsList.distributeUserList" :key="index"
								:label="item.userName" :value="item.userId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="业务类型">
						<el-select v-model="form.questionTypeId" placeholder="全部" filterable clearable>
							<el-option v-for="(item, index) in sheetParamsList.questionTypeList" :key="index"
								:label="item.questionContent" :value="item.questionTypeId"></el-option>
						</el-select>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="flex-row-sb mt20">
			<div class="flex flex-warp">
				<div class="status-item mr20 mb20" :style="form.status == item.id ? statusStyle : ''"
					v-for="(item, index) in statusList" :key="index" @click="switchStatus(item.id)">
					{{ item.title }}
					<div class="status-count" v-show="!['-1', '4', '5'].includes(item.id) && statusCount[item.key] > 0">
						{{ statusCount[item.key] }}
					</div>
				</div>
				<el-form inline size="mini">
					<el-form-item style="margin-top: 5px;" label="刷新时间">
						<el-select style="width: 120px;" v-model="refreshTime" placeholder="1分钟" filterable>
							<el-option label="1分钟" :value="60000"></el-option>
							<el-option label="5分钟" :value="300000"></el-option>
							<el-option label="10分钟" :value="600000"></el-option>
							<el-option label="30分钟" :value="1800000"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div class="flex">
				<div class="box-btn flex-all-center" @click="openAdd" v-if="(userType === '0' || userType === '1') && isShowAddBtn">
					<img src="@/assets/images/btn_add_icon.png" width="12" height="12" />
					<span>新建工单</span>
				</div>
				<div class="export-btn flex-all-center" @click="exportOrder">
					<img src="@/assets/images/gd_icon_daochu.png" width="19" height="17" />
					<span>导出工单</span>
				</div>
			</div>
		</div>

		<work-order-list :list="list" :btns="btns" @refresh="onSearch" v-if="list.length > 0"></work-order-list>
		<div class="no-data" v-else-if="!loading">暂无工单数据</div>

		<el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="form.page"
			@current-change="getSheetList" class="box-paging">
		</el-pagination>

		<add-order @refresh="onSearch" ref="addOrder"></add-order>
	</div>
</template>

<script>
	import WorkOrderList from '@/components/WorkOrder/WorkOrderList.vue'
	import AddOrder from '@/components/WorkOrder/AddOrder.vue'
	let timer = '';
	export default {
		components: {
			WorkOrderList,
			AddOrder
		},
		data() {
			return {
				// 筛选条件
				form: {
					startUserId: '',
					doUserId: '',
					distributeUserId: '',
					questionTypeId: '',
					status: '',
					keyword: '',
					limit: 10,
					page: 1,
					date: []
				},

				statusList: [{
						id: '-1',
						title: '全部',
						key: 'all'
					},
					/* {
						id: '6',
						title: '进行中',
						key: 'ing'
					}, */
					{
						id: '0',
						title: '待分配',
						key: 'distribute'
					},
					{
						id: '1',
						title: '待接单',
						key: 'receive'
					},
					{
						id: '2',
						title: '处理中',
						key: 'on'
					},
					{
						id: '3',
						title: '待验收',
						key: 'replay'
					},
					{
						id: '4',
						title: '已完成'
					},
					{
						id: '5',
						title: '已撤销'
					}
				],
				statusStyle: {
					background: 'linear-gradient(90deg, #3682FF, #4D9FFF)',
					color: '#FFFFFF'
				},

				sheetParamsList: [], // 问题筛选列表
				refreshTime: 60000,
				list: [], // 工单列表
				total: 1,
				loading: false,
				moreSearch: false,
				type: '0', // 我的工单  1 全部工单
				statusCount: {}
			}
		},
		computed: {
			// 按钮权限
			btns() {
				return this.$route.meta.btns
			},
			// 当前登录用户角色类型
			userType() {
				return this.$store.state.user.userType
			},
			// 服务是否已延期
			isShowAddBtn(){
				let showAddBtn = sessionStorage.getItem('endDay');
				if(showAddBtn && Number(showAddBtn)<0){
					return false;
				}else{
					return true;
				}
			}
		},
		watch: {
			// form: {
			//   handler() {
			//     this.getSheetList()
			//     this.getOrderStatusCount()
			//   },
			//   deep: true
			// },
			refreshTime(v1, v2){
				clearInterval(timer);
				timer = setInterval(_ => {
					this.onSearch();
				}, v1)
			}
		},
		mounted() {
			// 超管直接查看所有工单
			if (this.userType == '0') {
				this.type = '1'
			}

			// 设置默认工单筛选状态
			this.form.status = this.statusList[0].id

			// 获取数据
			this.onSearch();
			this.getSheetParamsList()
			clearInterval(timer);
			timer = setInterval(_ => {
				this.onSearch();
			}, this.refreshTime)
		},
		methods: {
			onSearch() {
				this.getSheetList()
				this.getOrderStatusCount()
			},
			resetTimer(){
				clearInterval(timer);
				timer = setInterval(_ => {
					this.onSearch();
				}, this.refreshTime)
			},
			// 获取工单列表
			getSheetList() {
				const {
					date
				} = this.form
				let startTime, endTime
				if (date && date.length > 0)[startTime, endTime] = date

				const type = this.type == '0' ? 'mySheetList' : 'sheetList'

				this.loading = true

				this.$api.order[type]({
						...this.form,
						date: undefined,
						startTime,
						endTime
					})
					.then(({
						data
					}) => {
						this.loading = false
						if (data.code == 200) {
							this.list = data.data
							this.total = data.total
						}
					})
					.catch(() => {
						this.loading = false
					})
			},

			// 选择工单状态
			switchStatus(id) {
				this.form.status = id
				this.onSearch()
			},

			// 获取筛选列表
			getSheetParamsList() {
				this.$api.order.sheetParamsList(this.type).then(({
					data
				}) => {
					if (data.code == 200) {
						this.sheetParamsList = data.data
					}
				})
			},

			// 获取工单列表对应状态数量
			async getOrderStatusCount() {
				const {
					date
				} = this.form
				let startTime, endTime
				if (date && date.length > 0)[startTime, endTime] = date
				const params = {
					...this.form,
					date: undefined,
					startTime,
					endTime,
					countType: this.type
				}
				const {
					data
				} = await this.$api.order.sheetListCount(params)
				if (data.code === 200) {
					this.statusCount = data.data
					return data.data;
				}
			},

			// 导出工单
			exportOrder() {
				const url =
					process.env.VUE_APP_SERVER_URL + '/pc/clientApi/sheet/sheetListExport'
				let params = ''

				// 获取参数
				const obj = JSON.parse(JSON.stringify(this.form))
				if (obj.date && obj.date.length > 0) {
					obj.startTime = obj.date[0]
					obj.endTime = obj.date[1]
				} else {
					obj.startTime = ''
					obj.endTime = ''
				}
				obj.type = this.type
				obj.userToken = sessionStorage.getItem('token') || ''
				delete obj.date
				delete obj.page
				delete obj.limit

				for (const k in obj) {
					if (params) {
						params += `&${k}=${obj[k]}`
					} else {
						params = `?${k}=${obj[k]}`
					}
				}
				window.open(url + params)
			},

			// 新建工单
			openAdd() {
				this.$refs.addOrder.open()
			}
		}
	}
</script>
<style lang="scss" scoped>
	/deep/ .search-form {
		margin-left: 50px;

		.el-select {
			width: 120px;
		}

		.el-input {
			width: 120px;
		}
	}

	.status-item {
		width: 112px;
		height: 36px;
		background: rgba(41, 48, 82, 0.05);
		border-radius: 4px;
		text-align: center;
		line-height: 36px;
		font-size: 14px;
		color: #999999;
		cursor: pointer;
		position: relative;

		&:last-child {
			margin-right: 0;
		}

		.status-count {
			position: absolute;
			top: -5px;
			right: -5px;
			width: 20px;
			height: 20px;
			background: red;
			border-radius: 50%;
			color: #fff;
			font-size: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.export-btn {
		width: 112px;
		height: 36px;
		margin-left: 20px;
		background: linear-gradient(90deg, #5d63ff, #7b82ff);
		border-radius: 4px;
		text-align: center;
		line-height: 36px;
		font-size: 14px;
		color: #ffffff;
		cursor: pointer;

		img {
			width: 18px;
			height: 16px;
			margin-right: 7px;
		}
	}

	.no-data {
		padding: 30px 0;
		text-align: center;
		color: #999;
	}
</style>
